import Layout from "@/views/layout/layout";
import Child from "@/views/layout/child";
const rootPath = "/cust";

const customerRouter = {
  path: rootPath,
  name: "customer",
  description: "고객센터",
  redirect: rootPath + "/faq",
  component: Layout,
  children: [
    {
      path: "faq",
      name: "faq",
      description: "faq",
      component: () => import("@/views/templates/customer/faq"),
    },
    {
      path: "otpTtmRvisn",
      name: "otpTtmRvisn",
      redirect: { name: "otpTtmRvisnStep1" },
      description: "OTP시간보정",
      component: () => import("@/views/templates/customer/otpTtmRvisn"),
      meta: {
        // roles: ["login"],
      },
      children: [
        {
          path: "step1",
          name: "otpTtmRvisnStep1",
          description: "OTP시간보정-step1",
          component: () => import("@/views/templates/customer/otpTtmRvisnStep1"),
          meta: {
            step: 1,
          },
        },
        {
          path: "step2",
          name: "otpTtmRvisnStep2",
          description: "OTP시간보정-step2",
          component: () => import("@/views/templates/customer/otpTtmRvisnStep2"),
          meta: {
            step: 2,
          },
        },
        {
          path: "step3",
          name: "otpTtmRvisnStep3",
          description: "OTP시간보정-step3",
          component: () => import("@/views/templates/customer/otpTtmRvisnStep3"),
          meta: {
            isLast: true,
          },
        },
      ],
    },
    {
      path: "advOtpUnlock",
      name: "advOtpUnlock",
      redirect: { name: "advOtpUnlockStep1" },
      description: "AdvancedOTP잠금해제",
      component: () => import("@/views/templates/customer/advOtpUnlock"),
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "step1",
          name: "advOtpUnlockStep1",
          description: "AdvancedOTP잠금해제-step1",
          component: () => import("@/views/templates/customer/advOtpUnlockStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "advOtpUnlockStep2",
          description: "AdvancedOTP잠금해제-step2",
          component: () => import("@/views/templates/customer/advOtpUnlockStep2"),
          meta: {
            step: 2,
            roles: ["login"],
          },
        },
        {
          path: "step3",
          name: "advOtpUnlockStep3",
          description: "AdvancedOTP잠금해제-step3",
          component: () => import("@/views/templates/customer/advOtpUnlockStep3"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
      ],
    },
    {
      path: "cddEddForVtn",
      name: "cddEddForVtn",
      description: "베트남 고객확인의무(CDD/EDD)",
      component: () => import("@/views/templates/customer/cddEddForVtn"),
    },
    {
      path: "aboutus",
      redirect: { name: "customerCounsel" },
      description: "이용안내",
      component: Child,
      children: [
        {
          path: "customerCounsel",
          name: "customerCounsel",
          description: "고객상담",
          component: () => import("@/views/templates/customer/customerCounsel"),
        },
        {
          path: "location",
          name: "location",
          description: "위치안내",
          component: () => import("@/views/templates/customer/location"),
        },
        {
          path: "supportEnvironment",
          name: "supportEnvironment",
          description: "지원 환경",
          component: () => import("@/views/templates/customer/supportEnvironment"),
        },
        {
          path: "openSourceLicense",
          name: "openSourceLicense",
          description: "오픈소스 라이선스",
          component: () => import("@/views/templates/customer/openSourceLicense"),
        },
      ],
    },
    {
      path: "news",
      redirect: { name: "newsList" },
      description: "공지/새소식",
      component: Child,
      children: [
        {
          path: "list",
          name: "newsList",
          description: "공지/새소식 목록",
          component: () => import("@/views/templates/customer/newsList"),
          meta: {
            step: 1,
          },
        },
        {
          path: "detail",
          name: "newsDetail",
          description: "공지/새소식 상세",
          component: () => import("@/views/templates/customer/newsDetail"),
          meta: {
            step: 2,
          },
        },
      ],
    },
    {
      path: "mmrFinancialStatements",
      redirect: { name: "mmrFinancialStatements" },
      description: "미얀마 재무제표",
      component: Child,
      children: [
        {
          path: "list",
          name: "mmrFinancialStatements",
          description: "미얀마 재무제표 목록",
          component: () => import("@/views/templates/customer/mmrFinancialStatements"),
          meta: {
            step: 1,
          },
        },
        {
          path: "detail",
          name: "mmrFinancialStatementsDetail",
          description: "미얀마 재무제표 상세",
          component: () => import("@/views/templates/customer/mmrFinancialStatementsDetail"),
          meta: {
            step: 2,
          },
        },
      ],
    },
    {
      path: "reportAccountMmr",
      name: "reportAccountMmr",
      redirect: { name: "reportAccountMmrStep1" },
      description: "사고신고",
      component: () => import("@/views/templates/customer/reportAccountMmr"),
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "reportAccountMmrStep1",
          name: "reportAccountMmrStep1",
          description: "계좌사고신고 step1",
          component: () => import("@/views/templates/customer/reportAccountMmrStep1"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "reportAccountMmrStep2",
          name: "reportAccountMmrStep2",
          description: "계좌사고신고 step2",
          component: () => import("@/views/templates/customer/reportAccountMmrStep2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "reportAccountMmrStep3",
          name: "reportAccountMmrStep3",
          description: "계좌사고신고 step3",
          component: () => import("@/views/templates/customer/reportAccountMmrStep3"),
          meta: {
            roles: ["login"],
            isLast: true,
            transparent: true,
          },
        },
      ],
    },
    {
      path: "reportInternetBankingSuspension",
      name: "reportInternetBankingSuspension",
      redirect: { name: "reportInternetBankingSuspensionStep1" },
      description: "인터넷뱅킹이용정지",
      component: Child,
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "reportInternetBankingSuspensionStep1",
          name: "reportInternetBankingSuspensionStep1",
          description: "인터넷뱅킹이용정지 step1",
          component: () => import("@/views/templates/customer/reportInternetBankingSuspensionStep1"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "reportInternetBankingSuspensionStep2",
          name: "reportInternetBankingSuspensionStep2",
          description: "인터넷뱅킹이용정지 step2",
          component: () => import("@/views/templates/customer/reportInternetBankingSuspensionStep2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "reportInternetBankingSuspensionStep3",
          name: "reportInternetBankingSuspensionStep3",
          description: "인터넷뱅킹이용정지 step3",
          component: () => import("@/views/templates/customer/reportInternetBankingSuspensionStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            transparent: false,
            goback: false,
            menu: false,
          },
        },
        {
          path: "reportInternetBankingSuspensionStep4",
          name: "reportInternetBankingSuspensionStep4",
          description: "인터넷뱅킹이용정지 step4",
          component: () => import("@/views/templates/customer/reportInternetBankingSuspensionStep4"),
          meta: {
            roles: ["login"],
            isLast: true,
            transparent: true,
          },
        },
      ],
    },
    {
      path: "reportLostOrStolenCard",
      name: "reportLostOrStolenCard",
      redirect: { name: "reportLostOrStolenCardStep1" },
      description: "현금/직불카드 분실신고",
      component: Child,
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "reportLostOrStolenCardStep1",
          name: "reportLostOrStolenCardStep1",
          description: "현금/직불카드 분실신고 step1",
          component: () => import("@/views/templates/customer/reportLostOrStolenCardStep1"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "reportLostOrStolenCardStep2",
          name: "reportLostOrStolenCardStep2",
          description: "현금/직불카드 분실신고 step2",
          component: () => import("@/views/templates/customer/reportLostOrStolenCardStep2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "reportLostOrStolenCardStep3",
          name: "reportLostOrStolenCardStep3",
          description: "현금/직불카드 분실신고 step3",
          component: () => import("@/views/templates/customer/reportLostOrStolenCardStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            isLast: true,
            transparent: true,
          },
        },
      ],
    },

    {
      path: "reportLostOrStolenOtp",
      name: "reportLostOrStolenOtp",
      redirect: { name: "reportLostOrStolenOtpStep1" },
      description: "otp 분실신고",
      component: Child,
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "reportLostOrStolenOtpStep1",
          name: "reportLostOrStolenOtpStep1",
          description: "otp 분실신고 step1",
          component: () => import("@/views/templates/customer/reportLostOrStolenOtpStep1"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "reportLostOrStolenOtpStep2",
          name: "reportLostOrStolenOtpStep2",
          description: "otp 분실신고 step2",
          component: () => import("@/views/templates/customer/reportLostOrStolenOtpStep2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "reportLostOrStolenOtpStep3",
          name: "reportLostOrStolenOtpStep3",
          description: "otp 분실신고 step3",
          component: () => import("@/views/templates/customer/reportLostOrStolenOtpStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            isLast: true,
            transparent: true,
          },
        },
      ],
    },
    {
      path: "reportsInquiry",
      redirect: { name: "reportsInquiry1" },
      name: "reportsInquiry",
      description: "사고신고 내역조회",
      component: Child,
      meta: {
        roles: ["login"],
      },
      children: [
        {
          path: "reportsInquiry1",
          name: "reportsInquiry1",
          description: "사고신고 내역조회 step1",
          component: () => import("@/views/templates/customer/reportsInquiry"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "reportsInquiry2",
          name: "reportsInquiry2",
          description: "사고신고 내역조회 step1",
          component: () => import("@/views/templates/customer/reportsInquiry2"),
          meta: {
            roles: ["login"],
          },
        },
      ],
    },

    {
      path: "pushNotiStup",
      name: "pushNotiStup",
      description: "Push 알림 설정",
      component: () => import("@/views/templates/customer/pushNotiStup"),
      meta: {
        roles: ["login"],
      },
    },
  ],
};

export default customerRouter;
